/**
 * Scroll reveal: elements with [data-reveal] fade up (CSS in app.scss) when
 * they enter the viewport. One-shot per element; falls back to showing
 * everything immediately when IntersectionObserver is unavailable.
 */
(function () {
  const elements = document.querySelectorAll('[data-reveal]');

  if (!elements.length) {
    return;
  }

  if (!('IntersectionObserver' in window)) {
    elements.forEach((el) => el.classList.add('is-revealed'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.25 }
  );

  elements.forEach((el) => observer.observe(el));
})();
